import React from 'react'
import { Building2 } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminHospitals = () => {
  return (
    <GenericTable
      tableName="hospitals"
      title="Hospitals"
      icon={Building2}
      iconColor="purple"
      searchFields={['hospital_code', 'hospital_name', 'city', 'state', 'hospital_type']}
      hiddenFields={['hospital_id', 'created_at', 'updated_at']}
      primaryKey="hospital_id"
      defaultFields={['hospital_code', 'hospital_name', 'city', 'state', 'hospital_type', 'network_status', 'contact_phone']}
      addFields={['hospital_name', 'address', 'city', 'state', 'postal_code', 'contact_phone', 'contact_email', 'hospital_type']}
      editFields={[
        'hospital_name', 'address', 'city', 'state', 'postal_code', 'contact_phone', 'contact_email',
        'hospital_type', 'network_status', 'specialties', 'bed_count', 'emergency_services', 'insurance_accepted',
        'rating', 'website', 'description'
        // Excluded: hospital_id, hospital_code, created_at, updated_at
      ]}
    />
  )
}

export default AdminHospitals